import ForgotPassword from './forgotpassword-view';

export default ForgotPassword;
